// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assets-modal {
  max-width: 70vw;
  max-height: 70vh;
  min-height: 70vh;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .assets-modal {
    max-width: calc(100vw - 4rem);
    max-height: calc(100vh - 4rem);
    min-height: calc(100vh - 4rem);
  }
}
@media (max-width: 768px) {
  .assets-modal {
    max-width: calc(100vw - 2rem);
    max-height: calc(100vh - 2rem);
    min-height: calc(100vh - 2rem);
  }
}
.assets-modal .paylixecommerce-modal-body {
  flex: 1;
  overflow-y: auto;
}
@media (max-width: 768px) {
  .assets-modal .paylixecommerce-modal-body {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/main/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AACF;AACE;EATF;IAUI,6BAAA;IACA,8BAAA;IACA,8BAAA;EAEF;AACF;AAAE;EAfF;IAgBI,6BAAA;IACA,8BAAA;IACA,8BAAA;EAGF;AACF;AADE;EACE,OAAA;EACA,gBAAA;AAGJ;AADI;EAJF;IAKI,aAAA;EAIJ;AACF","sourcesContent":[".assets-modal {\n  max-width: calc(70vw);\n  max-height: calc(70vh);\n  min-height: calc(70vh);\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1024px) {\n    max-width: calc(100vw - 4rem);\n    max-height: calc(100vh - 4rem);\n    min-height: calc(100vh - 4rem);\n  }\n\n  @media (max-width: 768px) {\n    max-width: calc(100vw - 2rem);\n    max-height: calc(100vh - 2rem);\n    min-height: calc(100vh - 2rem);\n  }\n\n  .paylixecommerce-modal-body {\n    flex: 1;\n    overflow-y: auto;\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
